import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import CompareArrowsOutlinedIcon from '@material-ui/icons/CompareArrowsOutlined';
import DataUsageOutlinedIcon from '@material-ui/icons/DataUsageOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import TodayOutlinedIcon from '@material-ui/icons/TodayOutlined';
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined';
import { Link, useLocation } from "react-router-dom";
import BusinessIcon from '@material-ui/icons/Business';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import { useAuthContext } from '../context/Auth';
import { Collapse, Typography } from '@material-ui/core';
import { AccountBalanceOutlined, Business, DescriptionOutlined, ExpandLess, ExpandMore, FastfoodRounded, Group, HistoryOutlined, LocalOfferOutlined, Receipt, SettingsEthernetOutlined, StorefrontRounded, WorkOutline } from '@material-ui/icons';
import colors from './colors';
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  alignCenterItem: {
    display: 'flex',
    justifyContent: 'center'
  }
}));

const ListMenu = props => {

  const history = useHistory(); // Substitui useNavigate
  const location = useLocation(); // Obtém o caminho atual da URL
  const currentPath = location.pathname;
  const { userRoles, userInfos, isLoading } = useAuthContext();
  const classes = useStyles();
  const [sizeMenu, setSizeMenu] = useState('full');
  const [expandedGroups, setExpandedGroups] = useState({
    'Administrativo': true,
    'CRM': true,
    'Contábil': true,
    'Financeiro': true,
    'PDV': true,
  });

  useEffect(() => {
    console.log("expandedGroups: ", expandedGroups);
  }, [expandedGroups])

  useEffect(() => {
    setSizeMenu(props.sizeMenu)
  }, [props.sizeMenu])

  const toggleGroup = (group) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: !prev[group],
    }));
  };

  const items = [
    {
      title: 'Dashboard',
      to: '/',
      pathname: '/dashboard',
      icon: <DataUsageOutlinedIcon />,
      role: 1
    },
    {
      group: "Financeiro",
      items: [
        {
          title: 'Movimentações',
          to: '/movimentacoes',
          pathname: '/movimentacoes',
          icon: <CompareArrowsOutlinedIcon />,
          role: 2
        },
        {
          title: 'Centros de custo',
          to: '/centros-custos',
          pathname: '/centros-custos',
          icon: <LocalOfferOutlined />,
          role: 2
        },
        {
          title: 'Contas bancárias',
          to: '/contas-bancarias',
          pathname: '/contas-bancarias',
          icon: <AccountBalanceOutlined />,
          role: 2
        },
      ]
    },
    {
      group: "PDV",
      items: [
        {
          title: 'Frente de caixa',
          to: '/pdv',
          pathname: '/pdv',
          icon: <StorefrontRounded />,
          role: 11
        },
        {
          title: 'Movimentações',
          to: '/pdv-movimentacoes',
          pathname: '/pdv-movimentacoes',
          icon: <StorefrontRounded />,
          role: 11
        },
        {
          title: 'Configurações',
          to: '/pdv-configuracoes',
          pathname: '/pdv-configuracoes',
          icon: <SettingsEthernetOutlined />,
          role: 11
        },
      ]
    },
    {
      group: "Contábil",
      items: [
        {
          title: 'Notas Fiscais',
          to: '/nota-fiscal',
          pathname: '/nota-fiscal',
          icon: <DescriptionOutlinedIcon />,
          role: 4
        },
        {
          title: 'DRE',
          to: '/demonstrativo',
          pathname: '/demonstrativo',
          icon: <AssessmentOutlinedIcon />,
          role: 3
        },
        {
          title: 'Declarações & Guias',
          to: '/declaracoes-guias',
          pathname: '/declaracoes-guias',
          icon: <Receipt />,
          role: 13
        },
      ]
    },
    {
      group: "CRM",
      items: [
        {
          title: 'Clientes',
          to: '/clientes',
          pathname: '/clientes',
          icon: <Group />,
          role: 9
        },
        {
          title: 'Perguntas & Respostas',
          to: '/perguntas_respostas',
          pathname: '/perguntas_respostas',
          icon: <Receipt />,
          role: 9
        },
        {
          title: 'Agenda',
          to: '/calendario',
          pathname: '/calendario',
          icon: <TodayOutlinedIcon />,
          role: 5
        },
      ]
    },
    {
      group: "Administrativo",
      items: [
        {
          title: 'Colaboradores',
          to: '/funcionarios',
          pathname: '/funcionarios',
          icon: <WorkOutline />,
          role: 15
        },
        {
          title: 'Meu ponto',
          to: '/meu-ponto',
          pathname: '/meu-ponto',
          icon: <HistoryOutlined />,
          role: 15
        },
        {
          title: 'Fornecedores',
          to: '/fornecedores',
          pathname: '/fornecedores',
          icon: <Business />,
          role: 14
        },
        {
          title: 'Produtos/Serviços',
          to: '/meus-produtos',
          pathname: '/meus-produtos',
          icon: <FastfoodRounded />,
          role: 10
        },
        {
          title: 'Ordens de compra',
          to: '/ordens-compra',
          pathname: '/ordens-compra',
          icon: <DescriptionOutlined />,
          role: 10
        },
        {
          title: 'Relatórios',
          to: '/relatorios',
          pathname: '/relatorios',
          icon: <AssignmentOutlinedIcon />,
          role: 12
        },
        {
          title: 'Minhas empresas/filiais',
          to: '/empresas',
          pathname: '/empresas',
          icon: <BusinessIcon />,
          role: 6
        },
        {
          title: 'Usuários',
          to: '/acessos-usuarios',
          pathname: '/acessos-usuarios',
          icon: <PermIdentityOutlinedIcon />,
          role: 7
        },
      ]
    },
    {
      title: 'Minha conta',
      to: '/minha-conta',
      pathname: '/minha-conta',
      icon: <SettingsOutlinedIcon />,
      // role: 8
    }
  ];

  useEffect(() => {
    if (userRoles.length > 0 && userInfos?.user_id != null && currentPath !== '/minha-conta') {
      console.log("userRoles: ", userRoles);
  
      // Extrair todas as roles ativas do usuário
      const userRoleIds = userRoles
        .filter((role) => role.status === true)
        .map((role) => role.role_id);
      console.log("userRoleIds: ", userRoleIds);
  
      // Função para extrair os itens acessíveis considerando grupos
      const getAccessibleItems = (menuItems) => {
        return menuItems.reduce((acc, item) => {
          if (item.items) {
            // Caso seja um grupo, iterar sobre seus itens
            acc.push(...getAccessibleItems(item.items));
          } else if (!item.role || userRoleIds.includes(item.role)) {
            // Se o item não tiver role ou se a role for permitida
            acc.push(item);
          }
          return acc;
        }, []);
      };
  
      const accessibleItems = getAccessibleItems(items);
      console.log("accessibleItems: ", accessibleItems);
  
      // Verificar se a página atual está acessível
      const currentItem = accessibleItems.find((item) => item.pathname === currentPath);
  
      if (!currentItem) {
        // Redirecionar para a próxima página disponível ou para 'minha-conta' caso nenhuma esteja disponível
        const nextItem = accessibleItems[0] || items.find((item) => item.pathname === "/minha-conta");
        if (nextItem) {
          console.log("Redirecionando pois não tem acesso ao caminho atual");
          window.location.href = nextItem.pathname;
        }
      }
    }
  }, [userRoles, userInfos, currentPath, history]);  

  const Content = props => {
    return(
      <ListItem style={{ paddingLeft: sizeMenu != "small" && '32px' }} button className={sizeMenu && sizeMenu === "small" ? classes.alignCenterItem : ''}>
        <Tooltip title={props?.item?.title} disableHoverListener={sizeMenu && sizeMenu === "small" ? false : true}>
          <ListItemIcon style={{ minWidth: '36px' }} className={sizeMenu && sizeMenu === "small" ? classes.alignCenterItem : ''}>
            {React.cloneElement(props?.item.icon, {
              style: { 
                color: props?.localtionPathname === props?.item.pathname ? colors?.primary : 'gray',
                fontSize: '20px'
              }
            })}
          </ListItemIcon>
        </Tooltip>
        {!sizeMenu || sizeMenu === "full" && (
          <ListItemText 
            primary={props?.item?.title} 
            style={{ 
              color: props?.localtionPathname === props?.item?.pathname ? colors?.primary : 'gray' 
            }} 
          />
        )}
      </ListItem>
    )
  }

  return (
    <div className={classes.root}>
      <List style={{ width: '100%' }}>
        {isLoading ? (
          <Typography variant="body2" color="textSecondary" style={{ padding: '20px' }}>
            Carregando menu ...
          </Typography>
        ) : (
          items.map((item, index) => {
            if (item.items) {

              // Caso o item seja um grupo, renderiza o título do grupo e seus itens
              const isExpanded = expandedGroups[item.group] || false;

              return (
                <React.Fragment key={index}>
                  
                  {/* Cabeçalho do grupo */}
                  <ListItem button onClick={() => toggleGroup(item.group)}>
                    <ListItemText 
                      primary={sizeMenu === "small" ? item.group.substring(0, 3).toUpperCase() : item.group}
                      style={{ 
                        color: 'gray' 
                      }} 
                    />
                    {isExpanded ? <ExpandLess style={{ color: 'gray' }} /> : <ExpandMore style={{ color: 'gray' }} />}
                  </ListItem>

                  {/* Subitens do grupo */}
                  <Collapse in={isExpanded} timeout="auto" unmountOnExit>

                    {item.items.map((subItem, subIndex) => {
                      const hasAccess =
                        userInfos?.user_id === null ||
                        !subItem?.role ||
                        userRoles.some(
                          (role) => role.role_id === subItem.role && role.status === true
                        );

                      if (!hasAccess) return null;

                      return (
                        <Link
                          key={`sub-${subIndex}`}
                          onClick={() => props?.handleOnClick?.()}
                          to={subItem?.to}
                          style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
                        >
                          <Content localtionPathname={location.pathname} item={subItem} />
                        </Link>
                      );
                    })}
                  </Collapse>

                </React.Fragment>
              );
            } else {
              // Caso seja um item normal
              const hasAccess =
                userInfos?.user_id === null ||
                !item?.role ||
                userRoles.some(
                  (role) => role.role_id === item.role && role.status === true
                );

              if (!hasAccess) return null;

              return (
                <Link
                  key={index}
                  onClick={() => props?.handleOnClick?.()}
                  to={item?.to}
                  style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
                >
                  <Content localtionPathname={location.pathname} item={item} />
                </Link>
              );
            }
          })
        )}
      </List>

    </div>
  );
}

export default ListMenu;